module.exports = __webpack_public_path__ + "static/media/ebarchitects_kabeza202111.ea92d782.jpg";